import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
  // Карусель товаров из статьи
  const articleProductsCarouselEl = document.querySelector("[data-swiper='article-products-carousel']");
  let articleProductsCarouselInstance;
  if (articleProductsCarouselEl) {
      articleProductsCarouselInstance = new Swiper(articleProductsCarouselEl, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          updateOnWindowResize: true,
          preloadImages: false,
          lazy: true,
          autoHeight: true,
          modules: [Navigation],
          navigation: {
              nextEl: '.dh-article-products .swiper-next',
              prevEl: '.dh-article-products .swiper-prev',
          },
      });
  }
});
